import React from 'react'
import Terminal from 'react-console-emulator'
import { Typewriter } from 'react-simple-typewriter'


const commands = {
	whoami: {
		description: "Some info about me 🙋.",
		fn: () => {
			return (`Born in Argentina in 1992. I went to Law School at Universidad Catolica Argentina and graduated in 2017. \n
							 During my studies and after their completion, I worked in the private and public sectors, and got sick and tired of it all. The way one is intended to develop professionaly in that industry just didn't fit for me (lawyers and law students from my country will understand 🤦).\n 
							 In 2019 I quitted my job and travelled to France to live a work & travel experience 🇫🇷. Hands down, the best experience ever... until COVID struck 🦠😷.  \n
							 The pandemic forced me back home on December 2020. Jobless and determined to avoid at all costs working back as a lawyer/attorney 🙅, I decided to get into computer science, particularly into web development 🖥️.\n
							 Being very curious by nature, I've always been interested in understanding how things worked: computers being one of them. I thought: "why not give it a try?". After all, the worst thing that could happen was to actually learn something new 🤓😆.\n
							 I began learning by myself and when I heard about Soy Henry's web development intensive bootcamp, I enrolled, graduated and loved every single day of it (4 awesome months). On top of learning programming skills, I worked as a Teaching Assistant 🧑‍🏫 and met awesome people along the way. I reckon it was by far one of the best decisions I've made so far. \n 
							 Now, I am a full-time full stack web developer 🧑‍💻 and I just love it. I don't see myself doing anything else, it's just too cool 😎, and this is just the beginning 🚀.`)
		}
	},
	projects: {
		description: "Projects I've been working on 🦾.",
		fn: () => {
			return (`✅ "Changas" 👷 - Link to site: https://changas.vercel.app/ \n
			
			'Changas' is a service intermediary SPA, connecting the demand and supply of non-profesional working-force. 
			Repository here --> https://github.com/mmiglioranza22/Changas \n
			
			✅ "Food recipes" 🍔 - Link to site: https://recipes-spa-project.vercel.app/ \n
			This SPA was my very first project ever. It was an individual assignement at Henry's bootcamp. You cand search and create recipes with it.
			Repository here --> https://github.com/mmiglioranza22/recipes_SPA_project`

			)
		}
	},
	contact: {
		description: "How you can contact me 📫",
		fn: () => {
			return (`You can find me / reach out by any of these means 👇:\n
							 Email: 		mmiglioranza22@gmail.com
							 LinkedIn:	https://www.linkedin.com/in/manuel-miglioranza-dev/
							 GitHub: 		https://github.com/mmiglioranza22
							 `)
		}
	},
	tellmeajoke: {
		description: 'Hope you like terrible, slightly-dark dad jokes 🙃.',
		fn: () => {
			const arr = [
				`- Air used to be free at the gas station, now it's $1.50. You know why? \n- Inflation.`,
				`- What do sprinters eat before a race?\n- Nothing, they fast!`,
				`- When I was a kid, my mother told me I could be anyone I wanted to be. Turns out, identity theft is a crime.`,
				`- Why can't your nose be 12 inches long?\n- Because then it would be a foot.`,
				`- I have a fish that can breakdance. Only for ten seconds though, and only once.`,
				`- I just read that someone in London gets stabbed every 52 seconds. Poor bastard.`,
				`- Do you know the last thing my grandfather said to me before he kicked the bucket? “Grandson, watch how far I can kick this bucket.”`,
				`- What's the last thing to go through a fly's head as it hits the windshield of a car going 70 mph? \n- Its butt.`,
				`- When does a joke become a dad joke?\n- When it becomes apparent.`,
				`- I hate double standards. Burn a body at a crematorium, you're "being a respectful friend." Do it at home and you're "destroying evidence."`,
				`- Yesterday, I was washing the car with my son. He said, “Dad, can’t you just use a sponge?”`,
				`- I have a great joke about nepotism. But I’ll only tell it to my kids.`,
				`- I was reading a great book about an immortal dog the other day. It was impossible to put down.`,
				`- Where do you learn to make a banana split? Sundae school.`,
				`- What do you call a fake noodle? \n- An impasta.`,
				`- When is a door not a door? \n- When it’s actually ajar.`,
				`- How many tickles does it take to make an octopus laugh? \n- Ten tickles.`,
				`- As I get older, I remember all the people I lost along the way. Maybe a career as a tour guide was not the right choice.`,
				`- I tried to explain to my 4-year-old son that it’s perfectly normal to accidentally poop your pants. But he’s still making fun of me.`,
			]
			const i = Math.floor((Math.random() * arr.length))
			return arr[i]
		}
	},
}


export default function English() {


	return (

		<div id="container" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px" }}>
			<Terminal
				commands={commands}
				welcomeMessage={

					<Typewriter
						words={[`Hi there 👋! \n
												My name is Manuel Miglioranza and I am a full stack web developer 🧑‍💻.
												If you'd like to know more about me and the projects I've been working on, you can do so with this terminal. \n
												Type "help" to get started and "clear" to clean the console messages. 😁`]}
						loop={1}
						cursor
						cursorStyle=''
						typeSpeed={20}
						delaySpeed={50}
					/>

				}
				promptLabel={'~$'}
				style={{ width: "50%", height: "700px", borderRadius: "3px", backgroundColor: "#1E1E1E" }}
				contentStyle={{ fontSize: "17px", color: "#f153f1", borderRadius: "3px", backgroundColor: "#1E1E1E" }}
				inputAreaStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				promptLabelStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				inputTextStyle={{ color: "timberwolf", fontSize: "17px", paddingTop: "2px", marginTop: "6px", marginBottom: "4px" }}
				messageStyle={{ color: "white", marginTop: "4px", marginBottom: "4px", paddingTop: "2px", paddingBottom: "2px" }}
			/>
		</div>
	)
}
